import styled from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import { arrowDown, arrowUp } from 'styles/icons';
import { getColor, Theme } from 'styles/theme';

export const CrashCourseDropdownWrapper = styled.span`
  position: relative;
  padding: 8px 8px 16px 0px;
`;

export const CrashCourseDropdownLabel = styled.button<{ theme: Theme }>`
  display: inline-flex;
  align-items: center;
  gap: 24px;
  font-size: 24px;
  line-height: 36px;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: ${getColor('textPrimary')};
  font-family: ${font.graphikCond};
`;

export const Icon = styled.span<{ theme: Theme }>`
  display: flex;
  border-color: ${getColor('iconPrimary')};

  &.up {
    ${arrowUp}
  }
  &.down {
    ${arrowDown}
  }
`;

export const CrashCourseDropdownContent = styled.div<{ theme: Theme }>`
  position: absolute;
  left: 0;
  min-width: 240px;
  min-height: 50px;
  background-color: ${getColor('surfaceWhite')};
  z-index: 3;
  box-shadow: 0px 0px 20px ${`${getColor('surfaceBlack')}19`};
  border-radius: 0px 0px 8px 8px;
  margin-top: 10px;

  @media (${breakpoint.mmMin}) {
    margin-top: 20px;
  }

  @media (${breakpoint.mmMax}) {
    max-width: 200px;
    border-radius: 0px;
  }
`;
